import PhotoComment from ".";


export const photoCommentRoutes = () => [
  {
    path: "/admin/photo-comments",
    component: PhotoComment,
    layout: "admin",
    routeType: "admin",
    title: "Photos Management",
  },
];
